import { useEffect, useState } from 'react'

import { useAdditionalInfo, useAdditionalInfoActions } from '@/stores/useAdditionalInfoStore'

import { PickupDateChooser } from './pickup-date-chooser'
import { Textarea } from '@/app/[locale]/(ui)/textarea'

import { AddressInput } from '@/app/[locale]/(ui)/address-input'
import { useLocale, useTranslations } from 'next-intl'

export const PickupLocationForm = ({
  handleSelectedAddress,
  handleClearAddress,
  deliveryAddress,
  setIsInErrorState,
  pickupDateBag,
}: any) => {
  const [isValidDeliveryAddress, setIsValidDeliveryAddress] = useState(false)
  const [addressInputTouched, setAddressInputTouched] = useState(false)
  const [pickupDateInputTouched, setPickupDateInputTouched] = useState(false)

  const t = useTranslations()
  const locale = useLocale()

  const additionalInfo = useAdditionalInfo()
  const { setAdditionalInfo } = useAdditionalInfoActions()
  const additionalInfoMax = 255

  useEffect(() => {
    // Mark inputs as touched after user has interacted with them
    if (deliveryAddress && !addressInputTouched) setAddressInputTouched(true)
    if (pickupDateBag && !pickupDateInputTouched) setPickupDateInputTouched(true)
  }, [deliveryAddress, addressInputTouched, pickupDateBag, pickupDateInputTouched])

  return (
    <div className="flex flex-col gap-8">
      <div className="mb-[26px] flex flex-col gap-4">
        <h2 className="text-[1.875rem] font-bold">{t('Choose_your_pickup_location')}</h2>
        <p className="text-[1.25rem]">{t('Enter_an_address_to_choose')}</p>
      </div>
      <div>
        <AddressInput
          label={t('Pickup')}
          placeholder={t('Pickup_location_placeholder')}
          required
          whenAddressIsSelected={handleSelectedAddress}
          handleClearAddress={handleClearAddress}
          preSelectedAddress={deliveryAddress}
          isValidAddress={isValidDeliveryAddress}
          setIsValidAddress={setIsValidDeliveryAddress}
        />
      </div>
      <Textarea
        label={t('Optional_additional_information')}
        rows={4}
        maxLength={additionalInfoMax}
        placeholder={t('For_example_specific_pick-up_or')}
        value={additionalInfo}
        onChange={({ target }) => setAdditionalInfo(target.value)}
      />
      <PickupDateChooser locale={locale} setIsInErrorState={setIsInErrorState} />
    </div>
  )
}
